import { authCleanUp, getAuthToken } from '@airwallex/core/dist/webapp-auth-client';
// import { getApp } from '@airwallex/core/dist/widget-auth-client';
// import { TokenStorage } from '@airwallex/core/dist/widget-auth-sdk';
import type { AxiosError, AxiosInstance } from 'axios';
import axios from 'axios';
import get from 'lodash/get';

export const logoutAndRedirect = () => {
  authCleanUp();
  window.dispatchEvent(new CustomEvent('redirectToLogin'));
};

function stringifyAxiosErrorForAnalytics(error: AxiosError) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { toJSON: _, ...others } = error;
  return JSON.stringify(others);
}

export function stringifyError(error: unknown): string {
  if (error !== null && error !== undefined && axios.isAxiosError(error)) {
    return stringifyAxiosErrorForAnalytics(error);
  }
  return JSON.stringify(error);
}

export const client = axios.create({
  baseURL: '/api',
  headers: {
    'content-type': 'application/json',
  },
});

export const configureClientBaseUrl = (baseURL?: string): AxiosInstance => {
  client.defaults.baseURL = baseURL ? `${baseURL}` : '/api';
  return client;
};

client.interceptors.request.use((request) => {
  const isWebapp = true;
  const token = isWebapp ? getAuthToken() :"" ;

  if (!token && process.env.REACT_APP_MOCK !== 'true') {
    logoutAndRedirect();
  }

  if (request.headers) {
    request.headers['x-auth-token'] = token ?? '';
    // @ts-ignore
    if (window.airwallex?.region) {
      // @ts-ignore
      request.headers['x-region'] = window.airwallex.region;
    }

    const langKey = get(window, 'airwallex.i18n.langKey');
    if (langKey) {
      request.headers['x-lang-key'] = langKey;
    }
  }

  return request;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (get(error, 'response.status') === 401) {
      console.error(
        `Failed to authenticate the user, error: ${stringifyError(error)}`,
      );
    } else {
      console.error(`Failed api call, error: ${stringifyError(error)}`);
    }

    return Promise.reject(error);
  },
);
